import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { adminReadPermission } from '@internal/backstage-plugin-catalog-devops-common';

const rbacRolePage = PageBlueprint.make({
  name: 'rbacRolePage',
  params: {
    path: '/rbac/:roleId',
    loader: () =>
      import('./components/RolePage').then(m => (
        <RequirePermission permission={adminReadPermission}>
          <m.RolePageContext />
        </RequirePermission>
      )),
  },
});

const rbacRoleVersionPage = PageBlueprint.make({
  name: 'rbacRoleVersionPage',
  params: {
    path: '/rbac/:roleId/:roleVersionId',
    loader: () =>
      import('./components/RoleVersionPage').then(m => (
        <RequirePermission permission={adminReadPermission}>
          <m.RoleVersionPageContext />
        </RequirePermission>
      )),
  },
});

export default [rbacRolePage, rbacRoleVersionPage];
